<script lang="ts">
    import Tab from "@apps/iloom_customization/components/Tab.svelte";
    import Tabs from "@apps/iloom_customization/components/Tabs.svelte";

    import TabsManager from "@components/Tabs/TabsManager";

    export let tabs: { name: string; value: string }[];
    export let tabsManager: TabsManager;

    const openedTab$ = tabsManager.openedTab$;

    const onClick = (value: string) => {
        tabsManager.openTab(value);
    };
</script>

<Tabs class="gw-df-page__tabs">
    {#each tabs as tab}
        <Tab
            class="gw-df-page__tab"
            {tab}
            openedTab={$openedTab$}
            variant="rounded"
            {onClick}
        />
    {/each}
</Tabs>

<style lang="postcss">
    :global(.gw-tabs.gw-df-page__tabs) {
        margin-bottom: 48px;
    }

    @media all and (max-width: 834px) {
        :global(.gw-tabs.gw-df-page__tabs) {
            justify-content: flex-start;
        }
    }
    @media all and (max-width: 600px) {
        :global(.gw-tabs.gw-df-page__tabs) {
            margin-bottom: 30px;
        }
    }
</style>
